export default __webpack_public_path__ + "static/media/screen_chat_gpt_1.eae1b921.png";